import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { connect } from 'react-redux';
import baseStyles from '../../ElementControlsStyles';
import { CustomSvgIconButton } from 'crazyEditor/components/EditorUI/BaseUI/index';
import { TYPES, LAYOUT_CONTROL_PANELS } from 'crazyEditor/core/constants/panelConstants';
import { openLazyPanel } from 'crazyEditor/redux/modules/panel/panel';
import { shouldRenderAlignToPage } from './AlignObjectsControlPanel/AlignObjectsControlPanel';
import { getSelectedElements, getElementIdForDesktopElementControlView, isMultiSelect } from 'crazyEditor/redux/modules/element/elementSelectors';


@connect(
  (state) => ({
    selectedElementIds: getElementIdForDesktopElementControlView(state),
    selectedElements: getSelectedElements(state),
    isMultiSelect: isMultiSelect(state),
    viewMode: state.editor.viewMode
  }),
  {openLazyPanel}
)
@Radium
export default class LayoutControl extends Component {
  openPanel = (event, panel) => {
    const {openLazyPanel, selectedElementIds, selectedElements, isMultiSelect, viewMode} = this.props;
    openLazyPanel(panel, TYPES.LAYOUT_CONTROL_PANEL, event.currentTarget, {
      selectedElementIds,
      selectedElements,
      isMultiSelect,
      viewMode
    });
  };

  render() {
    const {selectedElements, isMultiSelect} = this.props;
    return (
      <div style={baseStyles.menuContainer}>
        <div style={baseStyles.menuTitle}>LAYOUT</div>
        <div style={baseStyles.menuBody}>
          <ul style={[baseStyles.menuBodyList]}>
            <li style={baseStyles.menuBodyListItem}>
              <CustomSvgIconButton
                iconPath="M2,2H16V16H2V2M22,8V22H8V18H10V20H20V10H18V8H22Z"
                tooltip="Arrange Elements"
                onClick={(event) => this.openPanel(event, LAYOUT_CONTROL_PANELS.ARRANGE)}
              />
            </li>
            {(shouldRenderAlignToPage(selectedElements) || isMultiSelect) &&
            <li style={baseStyles.menuBodyListItem}>
              <CustomSvgIconButton
                iconPath="M18,11H6V3H18v8Zm-2,4H4v4H16V15m2-2v8H2V13H18ZM22,0H20V24h2V0Z"
                tooltip="Align Elements"
                onClick={(event) => this.openPanel(event, LAYOUT_CONTROL_PANELS.ALIGN)}
              />
            </li>
            }
          </ul>
        </div>
      </div>
    );
  }
}